import { Component, OnDestroy, inject, signal } from '@angular/core';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { filter, Subscription } from 'rxjs';

import { ToastComponent } from './shared/components/toast/toast.component';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, ToastComponent],
  templateUrl: './app.html',
  styleUrl: './app.css'
})
export class App {
  protected readonly title = signal('matrix');

  private readonly router = inject(Router);
  private readonly sub = new Subscription();

  constructor() {
    // Initial
    this.applyBackgroundForUrl(this.router.url);

    // Updates on navigation
    this.sub.add(
      this.router.events
        .pipe(filter((e): e is NavigationEnd => e instanceof NavigationEnd))
        .subscribe((e) => this.applyBackgroundForUrl(e.urlAfterRedirects))
    );
  }

  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }

  private applyBackgroundForUrl(url: string): void {
    const path = url.split('?')[0] ?? url;
    const isDashboard = path === '/' || path === '';
    const isLogin = path.startsWith('/login');
    document.body.dataset['bg'] = isDashboard || isLogin ? 'dashboard' : 'base';
  }
}
